import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';
import { Box } from '@mui/material';

export const StyledMightyFuMainProduct = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-height: 32px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 100px;
  position: relative;
  display: flex;

  .product-img {
    min-width: 32px;
    max-width: 32px;
    display: flex;
    justify-content: center;
    position: relative;
  }

  img {
    position: absolute;
    height: 32px;
  }

  .text-container {
    margin-left: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    font-family: ${(props: any) => props.fontFamily};
    align-items: flex-start;

    &__stroked {
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-decoration: line-through;
      color: #ffff;
      font-size: 10px;
    }
  }
` as any;

export const StyledQuantity = styled(Box)<{ title: string }>`
  z-index: 1;

  .quantity_text {
    font-size: 14px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    color: #ffff;
    position: relative;
  }

  @media (min-width: ${breakpoints.mobileL}) {
    font-size: 14px;
  }
`;

export const StyledMightyFuSubProduct = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-height: 32px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 100px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

  .product-info {
    display: flex;
    align-items: center;
    justify-content: center;

    .product-img {
      min-width: 32px;
      max-width: 32px;
      display: flex;
      justify-content: center;
      position: relative;
    }

    .product-img img {
      height: 32px;
      width: 32px;
    }
  }

  .tooltip-icon {
    height: 24px;
  }
` as any;
